import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function heroSpacey() {
    const $comp = document.querySelector('.component--hero-spacey');
    if (!$comp) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        $comp.classList.add('is-ready');
        return;
    }

    const $headingGroup = $comp.querySelector('.hero-spacey__heading-group');
    if ($headingGroup) {
        gsap.to($headingGroup, {
            opacity: 0,
            ease: 'none',
            scrollTrigger: {
                trigger: $comp,
                start: 'top top',
                end: () => {
                    const pct = getComputedStyle($comp).getPropertyValue('--heading-fade-end').trim() || '30%';
                    return `${pct} top`;
                },
                scrub: true,
                invalidateOnRefresh: true,
            },
        });
    }

    const $imgGroup2 = $comp.querySelector('.hero-spacey__img-group--2');
    const $imgGroup2Landscape = $imgGroup2?.querySelector('.img-container--landscape');
    const $imgGroup2Portrait = $imgGroup2?.querySelector('.img-container--portrait');

    const sceneFor = ($group, end) => ({
        trigger: $group,
        start: 'top bottom',
        end,
        scrub: true,
        invalidateOnRefresh: true,
    });

    const xOffset = ($el, $group, xFromAmount = 1) => {
        const groupWidth = $group.offsetWidth;
        const elLeft = $el.offsetLeft;
        const elWidth = $el.offsetWidth;
        const elCenter = elLeft + elWidth / 2;
        const full = elCenter < groupWidth / 2
            ? -(elLeft + elWidth)
            : groupWidth - elLeft;
        return full * xFromAmount;
    };

    const easeX = gsap.parseEase('power2.out');

    const scrubWrap = ($container, {
        $group,
        xFromAmount = 0.2,
        yPercentFrom = 0,
        yPercentTo = 0,
        rotationFrom = 0,
    } = {}) => {
        const $wrap = $container.querySelector('.img-wrap');
        if (!$wrap || !$group) return;

        const applyXAndRotate = (self) => {
            const t = easeX(self.progress);
            gsap.set($wrap, {
                x: xOffset($container, $group, xFromAmount) * (1 - t),
                rotation: rotationFrom * (1 - t),
            });
        };

        ScrollTrigger.create({
            ...sceneFor($group, 'top top'),
            onRefresh: applyXAndRotate,
            onUpdate: applyXAndRotate,
        });

        gsap.fromTo($wrap, {
            yPercent: yPercentFrom,
        }, {
            yPercent: yPercentTo,
            ease: 'none',
            immediateRender: true,
            overwrite: false,
            scrollTrigger: {
                ...sceneFor($group, 'bottom top'),
                invalidateOnRefresh: false,
            },
        });
    };

    if ($imgGroup2 && $imgGroup2Portrait && $imgGroup2Landscape) {
        scrubWrap($imgGroup2Portrait, { $group: $imgGroup2, yPercentFrom: 40, rotationFrom: -3 });
        scrubWrap($imgGroup2Landscape, { $group: $imgGroup2, yPercentTo: 50, rotationFrom: 3 });
    }

    $comp.classList.add('is-ready');
}
